import List from '@/pages/admin/commissionPlans/List.vue';
import handleActivePaginationRouteProps from '@/utils/handleActivePaginationRouteProps.js';

export default [
  {
    path: 'commission_plans',
    name: 'commission-plans',
    component: List,
    props: handleActivePaginationRouteProps,
  },
];
